var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamesStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0546 0.972641C10.2402 0.609015 10.7598 0.609015 10.9454 0.97264L13.2708 5.52927C13.4887 5.95635 13.8977 6.2535 14.3712 6.32881L19.4234 7.13232C19.8266 7.19644 19.9872 7.69059 19.6987 7.97944L16.0837 11.5991C15.7448 11.9384 15.5886 12.4192 15.6633 12.8928L16.4603 17.946C16.5239 18.3493 16.1036 18.6547 15.7397 18.4696L11.1801 16.15C10.7528 15.9326 10.2472 15.9326 9.81987 16.15L5.26026 18.4696C4.8964 18.6547 4.47605 18.3493 4.53966 17.946L5.33669 12.8928C5.41139 12.4192 5.25517 11.9384 4.91635 11.5991L1.30132 7.97944C1.01284 7.69059 1.17339 7.19644 1.57657 7.13232L6.62877 6.32881C7.1023 6.2535 7.51129 5.95635 7.72924 5.52927L10.0546 0.972641Z",
    fill: "#263154",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesStarIcon);
export default __webpack_public_path__ + "static/media/games_star_icon.b8c34e50bc91d6f52f7ca2a926a7ef21.svg";
export { ForwardRef as ReactComponent };